<template>
  <div @touchmove.prevent class="member-center-tips" v-show="show">
    <div class="place"></div>
    <div class="tips-wrapper">
      <p class="desc">您已是 {{ userInfo.info.name }}，即刻开启权益生活吧</p>
      <div class="functional-btns">
        <button @click="goHome" class="home">现在就去</button>
        <!-- <button class="close" @click="close">立即续费</button> -->
        <button @click="$router.push({name: 'memberOrderRecords'})" class="records">开通记录</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'memberCenterTips',
  model: {
    prop: 'show',
    event: 'input'
  },
  props: {
    show: {
      type: Boolean
    }
  },
  computed: {
    ...mapState('store', [
      'userInfo'
    ])
  },
  methods: {
    goHome () {
      this.$router.push({ name: 'home' })
    },
    close () {
      this.$emit('close', false)
    }
  }
}
</script>

<style lang="less" scoped>
.member-center-tips {
  position: fixed;
  top: 0.88rem;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  background-color: transparent;
  .place {
    height: 3.6rem;
  }
  .tips-wrapper {
    position: absolute;
    top: 2.8rem;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    font-size: @fz26;
    color: #343330;
    background-color: #fff;
  }
  .desc {
    text-align: center;
    padding: 0.6rem 0.6rem 0.2rem;
  }
  .functional-btns {
    .flex-column-center;
    .home {
      width: 6.3rem;
      height: 0.8rem;
      font-size: @fz26;
      color: #fff;
      letter-spacing: 2px;
      margin-top: 0.2rem;
      background: linear-gradient(
        90deg,
        rgba(255, 130, 52, 1) 0%,
        rgba(250, 176, 80, 1) 100%
      );
      border-radius: 0.4rem;
    }
    .records {
      margin-top: 0.25rem;
      color: #4a90e2;
    }
    .close {
      color: #ff7373;
      border: 0.5px solid #ff7373;
      border-radius: 20px;
    }
  }
}
</style>
